module.exports = __webpack_public_path__ + "static/media/newborn.c610d13c.jpg";